import * as React from 'react';
import { useField, useForm } from 'react-final-form';
import { useTranslator } from '@gandi/translate';
import { Base, Block, BlockContent, Help } from '@gandi/ui';
import { useReadOnly } from '../../../../formUtils/readOnly';
import { useFormInitialValues } from '../../../../formUtils/useFormInitialValues';
import { useIsValidSection } from '../../../../formUtils/useIsValidSection';
import SectionActions from '../SectionActions';
import SectionHeader from '../SectionHeader';
import InputMailboxFieldGroup from './components/InputMailboxFieldGroup';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const sectionName = 'mailboxes';
const MailboxesSection = ({
  onDelete,
  disabled,
  ...blockProps
}) => {
  const {
    __
  } = useTranslator();
  const initialValues = useFormInitialValues();
  const {
    change,
    mutators
  } = useForm();
  const {
    input: {
      value: mailboxes
    }
    // $FlowFixMe[prop-missing]
  } = useField(sectionName, {
    subscription: {
      value: true
    }
  });
  const isValidSection = useIsValidSection(sectionName);
  const {
    readOnly,
    setReadOnly,
    toggleReadOnly
  } = useReadOnly(sectionName);
  React.useEffect(() => {
    // make sure the section exist for validation, this is only useful on mounting.
    change(`${sectionName}.section`, '1');
    if (!mailboxes || !mailboxes.mailbox1 && !mailboxes.mailbox2) {
      // Not read only on section creation.
      // In case values change, this readonly state must be handled by the
      // controller to prevent unexpected results, e.g. readOnly false without
      // the section
      setReadOnly(sectionName, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleDelete = () => {
    // ---
    // XXX: Field's submitErrors aren't cleared after removal which is probably a bug from final-form.
    mutators.clearSubmitError(sectionName);
    // ----
    change(sectionName, null);
    onDelete();
    setReadOnly(sectionName, true);
  };
  const handleCancel = () => {
    change(sectionName, initialValues?.mailboxes);
    setReadOnly(sectionName, true);
    if (!initialValues?.mailboxes) {
      onDelete();
    }
  };
  const handleDone = () => {
    // TODO: validate section w/ dry-run?
    setReadOnly(sectionName, true);
  };
  return /*#__PURE__*/_jsxs(Block, {
    ...blockProps,
    children: [/*#__PURE__*/_jsx(SectionHeader, {
      title: __('Mailbox'),
      onEditToggle: () => toggleReadOnly(sectionName),
      readOnlyMode: readOnly,
      disabled: disabled
    }), /*#__PURE__*/_jsxs(BlockContent, {
      children: [/*#__PURE__*/_jsx(Base, {
        marginBottom: "small",
        children: /*#__PURE__*/_jsx(Help, {
          children: __('If you have mailboxes that are not yet configured, you can do so in this section.')
        })
      }), /*#__PURE__*/_jsx(Base, {
        marginBottom: "small",
        children: /*#__PURE__*/_jsx(InputMailboxFieldGroup, {
          name: `${sectionName}.mailbox1`,
          label: __('Mailbox 1'),
          required: !mailboxes?.mailbox2,
          readOnly: readOnly
        })
      }), /*#__PURE__*/_jsx(InputMailboxFieldGroup, {
        name: `${sectionName}.mailbox2`,
        label: __('Mailbox 2'),
        required: !mailboxes?.mailbox1,
        readOnly: readOnly
      })]
    }), !readOnly && /*#__PURE__*/_jsx(SectionActions, {
      isValidSection: isValidSection,
      onDone: handleDone,
      onDelete: handleDelete,
      onCancel: handleCancel
    })]
  });
};
export default MailboxesSection;